export default __webpack_public_path__ + "static/media/left_arrow.38cee164.svg";